import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import ZGrid from '../components/ZGrid';
import { withStyles } from '@material-ui/core/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import user from '../asset/images/vendor.png';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import classNames from 'classnames';


const drawerWidth = 240;

function Dashboard(props) {
  const classes=props.classes
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
   
    <Box>
        <ZGrid container spacing={1} item xs={12} md={12} className={classes.accountCard}>
        <ZGrid item xs={12} sm={4} md={4}>
          <Card className={classes.profileCard}>
            <CardContent>
              <div style={{display:"flex"}}>
                <img src={user} height={60} />
                <span className={classes.userWelcome} sx={{ fontFamily:" Noto Sans " }} color="text.secondary" gutterBottom>
                 Welcome
                </span>
            </div>
            </CardContent>
          </Card>
        </ZGrid>     

        <ZGrid item xs={12} sm={4} md={4}>
          <Card className={classes.profileCard}>
            <CardContent className={classes.cardContent}>
              <div>               
                <div className={classes.account} color="text.secondary" gutterBottom>
                  50120000762345
                </div>
                <div className={classes.balance}>
                <span style={{color:"#92278F", fontWeight:400}}>Balance : </span> (&#36;) 594.42
                </div>
            </div>
            </CardContent>
          </Card>
        </ZGrid>    

        <ZGrid item xs={12} sm={4} md={4}>
          <Card className={classes.profileCard}>
            <CardContent className={classes.cardContent}>
              <div>               
                <div className={classes.account} color="text.secondary" gutterBottom>
                  50120000754367
                </div>
                <div className={classes.balance}>
                <span style={{color:"#92278F", fontWeight:400}}>Balance : </span> (&#36;) 333.56
                </div>
            </div>
            </CardContent>
          </Card>
        </ZGrid>    
      </ZGrid>  
     

      <ZGrid container md={12}>
        <ZGrid item xs={12} sm={12} md={12}>
            <Card className={classes.profileCard}>
              <CardContent>
                <div className={classes.cardHeader}>Transaction History</div>
                <div className={classes.cardSubHeader}>Recent</div>
              </CardContent>

              <TableContainer component={Paper}>
                <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classNames(classes.table,classes.cardSubHeader)}>Date</TableCell>
                      <TableCell className={classNames(classes.table,classes.cardSubHeader)}>Narration</TableCell>
                      <TableCell className={classNames(classes.table,classes.cardSubHeader)} align="left">Ref. No.</TableCell>
                      <TableCell className={classNames(classes.table,classes.cardSubHeader)} align="right">Withdrawal</TableCell>
                      <TableCell className={classNames(classes.table,classes.cardSubHeader)} align="right">Deposit</TableCell>
                      <TableCell className={classNames(classes.table,classes.cardSubHeader)} align="right">Closing Balance</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                      <TableRow className={classes.tableRow}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell className={classes.table} component="th" scope="row">
                        10-Mar-2022
                        </TableCell>
                        <TableCell className={classes.table}>Webflow</TableCell>
                        <TableCell className={classes.table} align="left">50120000762345</TableCell>
                        <TableCell className={classes.table} align="right">9.18</TableCell>
                        <TableCell className={classes.table} align="right"></TableCell>
                        <TableCell className={classes.table} align="right">183.60</TableCell>
                      </TableRow>


                      <TableRow className={classes.tableRow}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell className={classes.table} component="th" scope="row">
                        09-Mar-2022
                        </TableCell>
                        <TableCell className={classes.table}>Electricity</TableCell>
                        <TableCell className={classes.table} align="left"> 50120000754367</TableCell>
                        <TableCell className={classes.table} align="right">2.62</TableCell>
                        <TableCell className={classes.table} align="right">6.56</TableCell>
                        <TableCell className={classes.table} align="right">187.54</TableCell>
                      </TableRow>

                      
                      <TableRow className={classes.tableRow}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell className={classes.table} component="th" scope="row">
                        17-Feb-2022
                        </TableCell>
                        <TableCell className={classes.table}>BillPay</TableCell>
                        <TableCell className={classes.table} align="left"> 50120000754367</TableCell>
                        <TableCell className={classes.table} align="right">9.18</TableCell>
                        <TableCell className={classes.table} align="right"></TableCell>
                        <TableCell className={classes.table} align="right">178.36</TableCell>
                      </TableRow>

                      <TableRow className={classes.tableRow}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell className={classes.table} component="th" scope="row">
                        12-Feb-2022
                        </TableCell>
                        <TableCell className={classes.table}>NEFT Dr-IOBA0001843 NETBANK- Savings</TableCell>
                        <TableCell className={classes.table} align="left"> 50120000754367</TableCell>
                        <TableCell className={classes.table} align="right">65.57</TableCell>
                        <TableCell className={classes.table} align="right"></TableCell>
                        <TableCell className={classes.table} align="right">112.79</TableCell>
                      </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
        </ZGrid> 
      </ZGrid>
    </Box>
            

  );
}

Dashboard.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};


const styles= (theme) =>({
    appBar: {
        position: "fixed",
        zIndex: theme.zIndex.drawer + 100,
        // backgroundColor: "#fff",
        backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
        // boxShadow:'none'
        boxShadow: '0px 0px 0px 0.5px rgb(0 0 0 / 9%)',        
        backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
        margin: "0px !important",
        '& .MuiToolbar-root':{
          padding:0,
          minHeight:90
        }
    },

    tableRow:{
      "&:hover":{
        cursor:"pointer",
        background:"#FFF8FF"
      }
    },

    accountCard:{
      margin:0.,
      marginBottom:20,
      width:"100%"
    },

    table:{
      fontFamily: 'Noto Sans !important',
      color:"#212529 !important",
      fontSize: "1rem !important"
    },

    iconTransaction:{
      '& .MuiSvgIcon-root':{
          transform: "rotate(45deg)",
          color: "#f1416c",
          width:"2em",
      }
    },

    account:{fontSize: "1.25rem", color: "#212529" },

    balance:{ color: "#212529",paddingTop: 15, fontSize: "1.15rem",fontWeight:600},

    userWelcome:{      
      display: "flex",
      alignItems: "center",
      marginLeft: 10,
        fontWeight: 600,
        textTransform:"uppercase",
        color: "#212529"
    },

    cardHeader:{ 
      fontWeight: "bold",
      textTransform:"uppercase",
      color: "#f7941d",
      fontFamily: 'Josefin Sans',
      fontSize:"1.25rem"
    },

      cardSubHeader:{
        color: "#212529",
        fontSize:14,
        padding:"20px 0px 10px 0px",
        fontWeight:"600 !important",
        color:"#92278F !important",
        fontFamily: 'Josefin Sans'
      },

    cardContent:{minHeight:60},

    avatar:{
      justifyContent: "flex-end",
      display: "flex",
      marginRight: 15
    },

    profileCard:{
      boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%) !important",
      borderRadius:"0.75rem !important",
      [theme.breakpoints.up('sm')]: {      
      '& div.MuiCardContent-root':{
        minHeight:113
      }
    }
    },

    listItemIcon:{
      '& .MuiSvgIcon-root':{
          fill:"#303778",
          display: "flex",
          alignItems: "center",
          width: "1.5em",
          height: "1.5em",
          background: "#92278F",
          fill: "#fff",
          borderRadius: "0.5rem",
          padding: 5,
          boxShadow: "0 0.25rem 0.375rem -0.0625rem rgb(20 20 20 / 12%), 0 0.125rem 0.25rem -0.0625rem rgb(20 20 20 / 7%) !important"
      }
    },

    listItemText:{
      '&:hover':{
        '& span.MuiTypography-root':{
          fontWeight:600,
        }
      },

      '& span.MuiTypography-root':{
        color:"#92278F",
        fontWeight:400,
        fontFamily: 'Noto Sans '
      }
    },

    listItem:{
      paddingRight:0,
      '&:hover':{
        paddingRight:0,
        borderRadius: "0.75rem",  
        background: "#FFF8FF",
          

        '& div.listItemText':{
          '& span.MuiTypography-root':{
            fontWeight:600,
          }
        },

        '& listItemIcon':{
          '& svg.MuiSvgIcon-root':{
            background: "#303778",
            fill: "#fff",
            borderRadius: "0.5rem",
            padding: 5,
          }
        }
      },
    },

    menuContent:{
      '& .MuiToolbar-root':{
        minHeight:90
      },

      '& .MuiPaper-root':{
        borderRight:"none",
        // background:"#f8f9fa !important"
      }
    },

    rightContent:{
      '& .MuiToolbar-root':{
        minHeight:90
      }
    },

    logo:{
        margin: "20px !important",        
        margin: "0px !important"
    },

    logoContainer:{
      background:"#fff",margin:15,display: "flex",
      alignItems: "center",
      padding:"0px 10px"
    },


    txtWelcome:{
      fontWeight:600,
      fontSize:16,
      margin:15,
      textTransform:"uppercase",
      fontFamily: "Noto Sans ",
      color:"#000000"
  },
})

export default withStyles (styles) (Dashboard);


// import * as React from 'react';


// export default function Dashboard(props) {
//   return <p>hi</p>
// }